import { Col } from 'reactstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import hasPermission from '../../../../Shared/hasPermission';

const ConfigHeader = () => {
    const dispatch = useDispatch();

    let practiceId = useSelector((state) => state.practice.practice?.id);

    const openConfigurationModal = () => {
        dispatch(actions.toggle.toggleConnectConfigModal(true));
        dispatch(
            actions.practice.setPracticeConfigModalWorkingPracticeId(practiceId)
        );
    };

    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const canConfigure = hasPermission(`Configuration`, permissions);

    return (
        <Col sm="12">
            {/* TODO: bootstrap breakpoint doulbe content */}
            <h2 className="py-2 pb-3 justify-content-between border-bottom border-light d-none d-md-flex">
                DataCo Configuration
                {canConfigure && (
                    <span
                        onClick={openConfigurationModal}
                        className="px-2 hover-child-x hoverable op-7">
                        <FontAwesomeIcon icon={faEdit} size="xs" />
                    </span>
                )}
            </h2>
            <h3 className="py-2 pb-3 d-flex justify-content-between border-bottom border-light d-md-none">
                DataCo Configuration
                {canConfigure && (
                    <span
                        onClick={openConfigurationModal}
                        className="px-2 hover-child-x hoverable op-7">
                        <FontAwesomeIcon icon={faEdit} size="xs" />
                    </span>
                )}
            </h3>
        </Col>
    );
};

export default ConfigHeader;
